
export enum EmployeeReviewActions
{
    MissingAction,
    Approved,
    Revoked,
    Change,
    DelegatedTo
}

export enum Quarter
{
    Q1,
    Q2,
    Q3,
    Q4
}